export default "__VITE_ASSET__CkzahyGS__"